<template>
  <div class="game-tr-step">
    <div
      v-if="stepData.audio && show"
      :style="setAudioStyle()"
      style="position: absolute; width: 100%; height: 100%; background: red; border-radius: 50%"
    >
      <div style="width: 100%; height: 100%; position: relative; cursor: pointer; left: 0" v-if="stepData.audio.icon">
        <img
          :src="giveMeImagePlease(stepData.audio.icon.audioOn)"
          style="width: 100%; height: 100%; position: absolute; left: 0"
          v-if="!audioStatus"
          @click="startPlay()"
        />
        <img
          :src="giveMeImagePlease(stepData.audio.icon.audioOff)"
          style="width: 100%; height: 100%; position: absolute; left: 0"
          v-if="audioStatus"
          @click="startPlay()"
        />
      </div>
      <svg
        v-if="!stepData.audio.icon"
        class="audio"
        @click="startPlay()"
        viewBox="0 0 24 24"
        style="width: 100%; height: 100%; position: absolute; left: 0"
      >
        <transition name="click-fade">
          <path
            class="audio-svg-button"
            v-if="!audioStatus"
            d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
          />
        </transition>
        <transition name="click-fade">
          <path
            class="audio-svg-button"
            v-if="audioStatus"
            d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
          />
        </transition>
      </svg>
    </div>
    <div
      :id="'step_' + stepData.index"
      class="stepp-button"
      :class="{ 'stepp-button-anim': stepData.animation && animationState }"
      :style="setConfig()"
      @click="
        openPop($event, stepData.index);
        animationState = false;
      "
    >
      {{ stepData.id }}
    </div>
    <b-popover
      :target="'step_' + stepData.index"
      :ref="'step_' + stepData.index"
      :show.sync="show"
      triggers="click"
      :placement="stepData.direction"
    >
      <div class="popover-body-step-text" v-html="stepData.textObj.text" :style="getStyle(stepData.textObj)"></div>
    </b-popover>
  </div>
</template>

<script>
import _ from 'lodash';
import { Howler } from 'howler';
import * as utils from '../../../Utils/inputUtils';
export default {
  name: 'tr-step',
  components: {},
  props: {
    config: {
      type: null,
      default: function() {
        return {};
      },
    },
    stepData: {
      type: null,
      default: function() {
        return {};
      },
    },
    showStep: {
      type: null,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      audioStatus: false,
      audio: null,
      animationState: true,
      status: false,
      canIPlay: true,
      // stepShowValue: this.showStep,
    };
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.stepData.audio) {
        this.setAudioConfig(this.stepData.audio.src, 1);
      }
    },
    setAudioConfig(src, volume) {
      this.audio = new Howl({
        src: this.giveMeImagePlease(src),
        autoplay: false,
        loop: false,
        volume: volume || 1,
        onend: () => {
          this.audioStatus = false;
          console.log('end');
        },
        onpause: () => {
          this.audioStatus = false;
          console.log('end');
        },
        onstop: () => {
          this.audioStatus = false;
          console.log('end');
        },
        onplay: () => {
          this.audioStatus = true;
          console.log('sztart');
        },
      });
      // this.startAudio();
    },
    startPlay() {
      if (!this.audioStatus) {
        this.audio.play();
      } else {
        this.stopPlay();
      }
    },
    startAudio() {
      this.audio.play();
    },
    stopPlay() {
      this.audio.stop();
    },
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    openPop($event, index) {
      this.show = !this.show;
      this.$emit('close-all', $event, { index: index });
      this.$emit('step-change', $event, { index: index, show: this.show });
      return this.show;
    },
    setConfig() {
      return {
        width: this.config.width + 'px',
        height: this.config.height + 'px',
        'font-size': this.config.fontSize + 'px',
        background: this.config.backgroundColor,
        color: this.config.color,
      };
    },
    setAudioStyle() {
      if (this.stepData.audio.position == 'top') {
        return {
          background: this.config.backgroundColor,
          top: -1 * this.config.height - 5 + 'px',
        };
      } else if (this.stepData.audio.position == 'bot') {
        return {
          background: this.config.backgroundColor,
          top: this.config.height + 5 + 'px',
        };
      } else if (this.stepData.audio.position == 'left') {
        return {
          background: this.config.backgroundColor,
          left: this.config.width - 5 + 'px',
        };
      } else if (this.stepData.audio.position == 'right') {
        return {
          background: this.config.backgroundColor,
          left: -1 * this.config.width + 5 + 'px',
        };
      }
      return {
        background: this.config.backgroundColor,
      };
    },
    getStyle(item) {
      item.width = item.width;
      item.height = item.height;
      return _.merge(this.getCustomStyle(item), {
        width: utils.elementWidth(item.width, 'px'),
        height: utils.elementHeight(item.height, 'px'),
      });
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function(value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
  },
  computed: {
    show: {
      get() {
        return this.showStep.show;
      },
      set(newValue) {
        // if (!newValue) {
        //   // this.$emit('change');
        //   this.$refs['step_' + this.stepData.id].$emit('close');
        // }
        if (newValue == false) {
          if (this.audio) {
            this.stopPlay();
          }
        }
        this.showStep.show = newValue;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
@import '~@/assets/sass/inputBase';

.game-tr-step {
  .stepp-button {
    border-radius: 100%;
    width: 45px;
    height: 45px;
    font-size: 29px;
    background: #f26f21;
    color: #fff;
    font-family: 'Calibri';
    font-weight: bold;
  }
  .audio {
    border-radius: 50%;
    height: 57px;
    width: 57px;
    color: $secondIconColor;
    background-color: $firstIconColor;
    transition: 0.2s;
    &:hover {
      // background-color: rgb(40, 196, 36);
      color: $firstIconColor;
      background-color: $secondIconColor;
      // .audio-icon {
      //     color: $secondIconColor;
      //     background-color: $firstIconColor;
      // }
      .audio-svg-button {
        fill: #00a8ec;
      }
    }
    .audio-svg-button {
      width: 100%;
      height: 100%;
      fill: white;
      transition: 0.2s;
    }
  }
}
</style>
<style lang="scss">
.popover.bs-popover-auto[x-placement^='top'] .arrow::after,
.popover.bs-popover-top .arrow::after {
  border-top-color: #f5f5dc !important;
}
.popover.bs-popover-auto[x-placement^='left'] .arrow::after,
.popover.bs-popover-left .arrow::after {
  border-left-color: #f5f5dc !important;
}
.popover.bs-popover-auto[x-placement^='right'] .arrow::after,
.popover.bs-popover-right .arrow::after {
  border-right-color: #f5f5dc !important;
}
.popover.bs-popover-auto[x-placement^='bottom'] .arrow::after,
.popover.bs-popover-bottom .arrow::after {
  border-bottom-color: #f5f5dc !important;
}
.popover {
  // background-color: #f5f5dc;

  // .arrow::after {
  //
  // }
  .popover-body {
    font-size: 25px;
    font-family: Calibri;
    padding: 0;
    background-color: #f5f5dc;
    // padding: 0.5rem 0.75rem;
    .popover-body-step-text {
      padding: 0.5rem 0.75rem;
      background-color: #f5f5dc;
      // background-color: red;
    }
  }
}
</style>
<style lang="sass">
.stepp-button-anim
  animation: 2s 0s pulseStepp 10 linear backwards

  @keyframes pulseStepp
    0%
      transform: scale(1)
    35%
      transform: scale(1.2)
    70%
      transform: scale(1)
</style>
